import React from "react";
import classNames from "classnames";
import styles from "./index.module.scss";
import { Header } from "./Header";
import { CustomizeBranding } from "./CustomizeBranding/CustomizeBranding";
import { Embed } from "./Embed/Embed";
import { Unpublish } from "./Unpublish/Unpublish";
import { Delete } from "./Delete/Delete";
import { Appearance } from "./appearance/Appearance";
import { PreviewPaneStore } from "../PreviewPaneStore";
import { getIt } from "@uikit/getIt";
import { useStore } from "imagica-uikit/dist/hooks/useStore";
import { PreviewPaneBloc } from "../PreviewPaneBloc";
import { ChargeYourCustomers } from "./ChargeYourCustomers/ChargeYourCustomers";
import { DomainName } from "@uiview/views/PreviewPane/Settings/DomainName/DomainName";

/**
 * publish v3 setting页面容器
 * 这里面最后组合setting页面下每一个模块
 */

export function SettingPage(props: { bloc: PreviewPaneBloc }) {
  const previewPaneStore = getIt(PreviewPaneStore);
  const previewPaneState = useStore(previewPaneStore).value;

  return (
    <div className={classNames(styles.settingPage, { [styles.showSettingPage]: previewPaneState.settingPageStatus })}>
      <Header />
      <section>
        <ChargeYourCustomers />
        <Appearance bloc={props.bloc} />
        <CustomizeBranding />
        <DomainName bloc={props.bloc} showSettingPage={previewPaneState.settingPageStatus} />
        <Embed />
        <Unpublish />
        <Delete />
      </section>
    </div>
  );
}
